import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/markets';

export default {
  async getMarkets(payload) {
    const params = getParamsFormObject(payload);
    const path = `${endPoint}${params}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async getMarketDetails(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateMarket(id, payload) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },

  async createMarket(payload) {
    const path = `${endPoint}`;
    const response = await axiosClient.post(path, payload);
    return response.data;
  },

  async deleteMarket(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.delete(path);
    return response.data;
  },
};
